import {
    GET_CARDS_REQUEST,
    GET_CARDS_SUCCESS,
    SEARCH_CARDS_REQUEST,
    SEARCH_CARDS_SUCCESS,
    SAVE_CARD_REQUEST,
    SAVE_CARD_SUCCESS,
    SAVE_CARD_TEMPORARILY,
    ADD_CARD_REQUEST,
    ADD_CARD_SUCCESS,
    EDIT_CARD_REQUEST,
    EDIT_CARD_SUCCESS,
    EDIT_CARD_TIME_PERIOD,
    DELETE_CARD_REQUEST,
    DELETE_CARD_SUCCESS,
    DELETE_CARD_FAIL,
    CLEAR_PAGE_REQUEST,
    CLEAR_PAGE_SUCCESS
} from '../constants/Cards'

const initialState = {
    cards: [],
    card: {},
    fetching: false,
    action: ''
}

export default function cards(state = initialState, action) {
    switch (action.type) {
        case GET_CARDS_REQUEST:
            return {...state, fetching: true, action: GET_CARDS_REQUEST};

        case GET_CARDS_SUCCESS: {
            return {...state, cards: action.payload, fetching: false, action: GET_CARDS_SUCCESS};
        }

        case SEARCH_CARDS_REQUEST:
            return {...state, fetching: true, action: SEARCH_CARDS_REQUEST};

        case SEARCH_CARDS_SUCCESS: {
            let cards = [];
            const keywords = action.payload.split(' ');

            for (const card of state.cards) {
                for (const keyword of keywords) {
                    const regexp = new RegExp(keyword, 'i');
                    if (card.firstName.search(regexp) !== -1 || card.lastName.search(regexp) !== -1 || card.companyId.search(regexp) !== -1) {
                        cards.push(card);
                    }
                }
            }
            cards = [...new Set(cards)]; //чтобы исключить дубли, которые появляются из-за совпадения по фамилии и имени одновременно
            return {...state, cards: cards, fetching: false, action: SEARCH_CARDS_SUCCESS};
        }

        case SAVE_CARD_REQUEST: {
            return {...state, card: state.cards, fetching: true, action: SAVE_CARD_REQUEST};
        }

        case SAVE_CARD_SUCCESS: {
            return {...state, card: action.payload, fetching: false, action: SAVE_CARD_SUCCESS};
        }

        case SAVE_CARD_TEMPORARILY: {
            return {...state, card: action.payload};
        }

        case ADD_CARD_REQUEST:
            return { ...state, card: {}, fetching: true, action: ADD_CARD_REQUEST };

        case ADD_CARD_SUCCESS: {
            return { ...state, fetching: false, action: ADD_CARD_SUCCESS };
        }

        case EDIT_CARD_REQUEST: {
            const id = parseInt(action.payload);

            for (let i = 0; i < state.cards.length; i++) {
                if (state.cards[i].id === id) {
                    return {...state, card: state.cards[i], fetching: true, action: EDIT_CARD_REQUEST};
                }
            }
            return { ...state, fetching: true, action: EDIT_CARD_REQUEST };
        }

        case EDIT_CARD_TIME_PERIOD: {
            let card = {...state.card};
            card.fixedPeriod = action.payload;

            return {...state, card: card};
        }

        case EDIT_CARD_SUCCESS: {
            return {...state, fetching: false, action: EDIT_CARD_SUCCESS};
        }

        case DELETE_CARD_REQUEST: {
            return {
                ...state,
                action: DELETE_CARD_REQUEST,
                card: {
                    ...state.card,
                    deleting: true,
                },
            };
        }

        case DELETE_CARD_SUCCESS: {
            return {
                ...state,
                card: {},
                action: DELETE_CARD_SUCCESS
            };
        }

        case DELETE_CARD_FAIL: {
            return {
                ...state,
                card: {
                    ...state.card,
                    deleting: false,
                    deletionFailed: true,
                },
                action: DELETE_CARD_SUCCESS
            };
        }

        case CLEAR_PAGE_REQUEST:
            return { ...state, fetching: true, action: CLEAR_PAGE_REQUEST };

        case CLEAR_PAGE_SUCCESS:
            return {...state, cards: action.payload, fetching: false, action: CLEAR_PAGE_SUCCESS};

        default:
            return state;
    }

}



// WEBPACK FOOTER //
// ./src/reducers/cards.js